// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSQV2_root__i2gmM","content":"LayoutSQV2_content__LX2PF","formSlot":"LayoutSQV2_formSlot__wLD1w"};